document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.products__faq a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
            var targetId = this.getAttribute('href').replace('#', '');
            var anchorElem = document.querySelector('a.anchor-link[name="' + targetId + '"]');
            if (anchorElem) {
                e.preventDefault();
                var acc_item = anchorElem.nextElementSibling;
                if (acc_item && acc_item.classList.contains('accordion__item')) {
                    if (!acc_item.classList.contains('accordion__item--open')) {
                        acc_item.classList.add('accordion__item--open');
                        acc_item.setAttribute('aria-expanded', 'true');
                    }
                    window.location.hash = targetId;
                }
            }
        });
    });
});
